import env from 'config/env';

const MOBILE_APP_USER_AGENT = env.MOBILE_APP_USER_AGENT || 'fs-app-ua';

function isMobileApp() {
	return window.navigator.userAgent.indexOf(MOBILE_APP_USER_AGENT) > -1;
}

export default isMobileApp;
